// import React from "react";
// import "../Style/about.css";
// import AboutOne from "../../../assets/company/company-one.png";
// import AboutTwo from "../../../assets/company/company-two.png";
// import AboutFour from "../../../assets/company/company-three.png";
// import { FeatureCard } from "../../../global/components/FeatureCard/FeatureCard";

// const AboutContent = () => {

//   return (
//     <div className="">
//       <div className="image-container pt-[170px] max-md:pt-[125px] pb-[100px] max-md:pb-[70px] custom-padding flex justify-center items-center">
//         {" "}
//         <div className="header-txt text-center w-full">
//           {/* Main heading text */}
//           <p className="text-white text-center font-poppins font-bold text-[32px] leading-normal max-w-[1300px] mx-auto md:text-[28px] max-md:text-[18px]">
//             Focused on technology and innovation to provide
//             <br />
//             <span className="block">
//               market-leading capabilities designed to protect
//             </span>
//             <span className="block">and enhance security.</span>
//           </p>
//           {/* Sub text */}
//           <p className="text-white font-poppins text-center text-[16px] font-medium leading-normal mt-6 self-stretch md:text-[14px] max-md:text-[12px]">
//             Our solutions deliver information and automation beyond traditional
//             door control, with intuitive ease of
//             <br />
//             use that extends the value of the technology—resulting in better ROI
//             and the lowest total cost of <br /> ownership (TCO).
//           </p>
//         </div>
//       </div>

//       <div className="bg-[#F5FAFF] max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 mt-4 md:mt-6 lg:mt-16 ">
//         <FeatureCard
//           image={AboutOne}
//           // label="Physical Access Control Systems | Sicunet Inc."
//           description="Sicunet Inc., headquartered in Norwood, Massachusetts, is a Boston-area leader in physical access control systems and security technology solutions. With over 200 years of combined experience in the security industry, our team specializes in designing, manufacturing, and deploying advanced access control and video security systems that protect facilities of every size.<br/><br/>For the past 20 years, Sicunet has been a trusted OEM designer and manufacturer of access control hardware and software, offering scalable solutions for commercial, industrial, and government applications. With over 100,000 systems deployed globally, we provide proven reliability, seamless integration, and long-term performance.<br/><br/>At Sicunet, we take pride in our service-first philosophy, building honest and transparent partnerships with security integrators and end users. Our feature-rich, cost-effective access control products help organizations enhance safety, streamline operations, and stay competitive in a rapidly evolving security landscape." imageLeft={true} subtitle={"Who we are ?"}
//         />
//         <FeatureCard
//           image={AboutTwo}
//           label="Why Choose Sicunet ?"
//           description="<p style='color: black; font-family: Poppins; font-size: 16px; font-weight: 700; line-height: 1.5; margin-bottom: 10px; text-align: right;'>For Integrators</p>
// <div style='font-size: 13px; line-height: 1.4; margin-bottom: 8px; text-align: right;'>
// <p>• <strong>Flexible platform</strong> : Available in both Cloud and on-premise configurations using the same hardware.</p>
// <p>• <strong>No software installation</strong> : Operates directly through any web browser, reducing setup and maintenance time.</p>
// <p>• <strong>Fast deployment</strong> : Simplified configuration and management from any computer or mobile device.</p>
// <p>• <strong>Lower support costs</strong> : Easy updates and remote access tools keep systems running smoothly.</p>
// <p>• <strong>Reliable hardware</strong> : Choose from 1-, 2-, 4-, or 8-door panels with optimized layouts and clearly labeled terminals.</p>
// </div>
// <p style='color: black; font-family: Poppins; font-size: 16px; font-weight: 700; line-height: 1.2; margin-bottom: 8px; text-align: right;'>For End Users</p>
// <div style='font-size: 13px; line-height: 1.3; text-align: right;'>
// <p>• <strong>Simple, intuitive interface</strong> : Manage all doors, users, and devices from your browser or smartphone.</p>
// <p>• <strong>Real-time control</strong> : Instantly lock/unlock doors, update credentials, view video events, and trigger emergency commands.</p>
// <p>• <strong>Seamless scalability</strong> : Works for single-site or multi-facility operations.</p>
// <p>• <strong>Always accessible</strong> : Cloud or on-premises setup ensures you own your data and maintain complete control.</p>
// <p>• <strong>Trusted partner</strong> : Backed by Sicunet's commitment to innovation, reliability, and customer satisfaction.</p>
// </div>"
//           imageLeft={false}
//           // subtitle={"Physical Access Control"}
//           featureItems={[]}
//         />
//         <FeatureCard
//           image={AboutFour}
//           // label="Industries We Serve"
//           description="<p style='color: #121212; font-family: Poppins; font-size: 18px; font-weight: 700; margin-bottom: 10px; '>Industries We Serve</p>
// <div style='font-size: 13px;  '>
// <p >• <strong>K-12 Education</strong> : Secure campuses with integrated door control and video monitoring.</p>
// <p >• <strong>Houses of Worship</strong> : Protect facilities with easy-to-use, scalable security solutions.</p>
// <p >• <strong>Multi-Tenant & Commercial Buildings</strong> : Centralized management for multiple access points.</p>
// <p >• <strong>Banking & Financial Institutions</strong> : Ensure data integrity and physical asset protection.</p>
// <p >• <strong>Healthcare Facilities</strong> : Maintain compliance and patient safety with secure access zones.</p>
// </div>
// <p style='color: #4A4C56; font-family: Poppins; font-size: 13px; font-weight: 400; margin-bottom: 10px'>Sicunet's proven solutions protect over 100,000 installations worldwide, delivering reliable, flexible security for organizations of all sizes.</p>
// <p style='color: #121212; font-family: Poppins; font-size: 16px; font-weight: 600; margin-bottom: 10px '>Technology & Integration</p>
// <div style='font-size: 13px; '>
// <p >• <strong>Ethernet-Based Architecture</strong> : A third-generation embedded video surveillance system built for speed and reliability.</p>
// <p >• <strong>Unified Platform</strong> : Access control and video management software operate together for a stable, efficient system.</p>
// <p >• <strong>Full Visibility</strong> : Monitor and control every connected device through an intuitive, browser-based interface.</p>
// <p >• <strong>Easy Integration</strong> : Works seamlessly with existing infrastructure and common security hardware.</p>
// </div>
// <p style='color: #4A4C56; font-family: Poppins; font-size: 13px; font-weight: 400;  '>Sicunet's integrated technology provides a future-ready foundation for total access control and video security management.</p>"
//           subtitle={"What we do"}
//           imageLeft={true}
//           featureItems={[]}
//         />
//       </div>

//       {/* Assurance & Credibility Section */}
//       <div className="relative mt-4 md:mt-6 lg:mt-16">
//         <div className="max-w-[1200px]  mx-auto flex flex-col justify-center items-center px-[120px] max-md:px-6 max-md:py-10 py-[40px] min-h-[333px] relative z-10">
//           <h1 className="text-[52px] max-md:text-[32px] font-semibold max-md:leading-[44px] leading-[67.2px] text-center text-black font-['Poppins']">
//             Ensuring Quality
//           </h1>
//           <p className="text-[14px] leading-normal text-center mt-6 w-[778px] max-md:w-full text-[#3B3B3B] font-['Poppins']">
//             We provide exceptional service and technical support, offering fast,
//             reliable assistance for product inquiries, system troubleshooting,
//             and maintenance needs. Our authorized dealers deliver dependable
//             pre- and post-sales service, ensuring every customer receives expert
//             guidance, responsive support, and long-term product performance.
//           </p>
//         </div>

//         <div className="w-full h-full absolute top-0 left-0 bg-[#DDD] z-1"></div>
//       </div>
//     </div>
//   );
// };

// export default AboutContent;


// import { useState } from "react";
// import { ReactComponent as CompanyFig1 } from "../../../assets/svg/company-one.svg";
// import { ReactComponent as CompanyFig2 } from "../../../assets/svg/company-two.svg";
// import { ReactComponent as CompanyFig3 } from "../../../assets/svg/company-three.svg";
// import { endUserFeatures, forYouFeatures, industries, stats, techFeatures, whoWeAreFeatures } from "./CompanyData";


// export default function CompanyUI() {
//   const [activeTab, setActiveTab] = useState("integrators");

//   return (
//     <div className="font-sans bg-white">
//       {/* HERO */}
//       <section className="pt-28 pb-16 px-20 2xl:px-8 lg:px-21 max-w-[1440px] bg-[#FFF] mx-auto ">
//         <div className="max-w-[680px]">
//           <h1 className="text-[32px] font-medium leading-tight text-black">
//             We secure the places<br />
//             where people <span className="text-[#2350BF]">live and work</span>
//           </h1>
//           <p className="mt-6 text-[15px] text-[#5B5B5B] leading-relaxed">
//             Sicunet Inc. is a Boston-area leader in physical access control and video security 20 years manufacturing hardware and software that protects over 100,000 installations worldwide.
//           </p>
//         </div>

//         <div className="mt-16 flex justify-end gap-16">
//           {stats.map((s) => (
//             <div key={s.value} className="text-center">
//               <div className="text-4xl font-bold text-[#2350BF]">{s.value}</div>
//               <div className="text-sm text-[#5B5B5B] mt-2">{s.label}</div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* 01 — WHO WE ARE */}
//       <section className="py-16 px-8 lg:px-28 bg-[#F8F8F8]">
//         <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row gap-24">
//           <div className="flex-1 max-w-[588px]">
//             <div className="text-[#2350BF] text-sm font-medium tracking-widest mb-3">01 — Who we are</div>
//             <h2 className="text-3xl font-medium text-[#2350BF] leading-tight mb-8">
//               Built in Boston. Trusted globally.
//             </h2>
//             <div className="space-y-6 text-[#5B5B5B] text-[16px] leading-[26px]">
//               <p>Sicunet Inc., headquartered in Norwood, Massachusetts, is a Boston-area leader in physical access control systems and security technology solutions.</p>
//               <p>With over 20 years of combined experience in the security industry, our team specializes in designing, manufacturing, and deploying advanced access control and video security systems that protect facilities of every size.</p>
//               <p>At Sicunet, we take pride in our service-first philosophy, building honest and transparent partnerships with security integrators and end users. Our feature-rich, cost-effective access control products help organizations enhance safety, streamline operations, and stay competitive in a rapidly evolving security landscape.</p>
//             </div>
//           </div>

//           <div className="flex-1 space-y-6">
//             <div className="bg-white rounded-2xl p-8 shadow-sm">
//               <CompanyFig1 />
//             </div>

//             {whoWeAreFeatures.map((f, i) => (
//               <div key={i} className="bg-white rounded-2xl p-6 flex gap-5 border border-[#BFD1FF]">
//                 <div className="w-12 h-12 bg-[#EFF6FF] rounded-2xl flex items-center justify-center flex-shrink-0 text-2xl">
//                   {f.icon}
//                 </div>
//                 <div>
//                   <div className="font-semibold text-[#0F172A]">{f.title}</div>
//                   <div className="text-sm text-[#5B5B5B] mt-1">{f.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 02 — BUILT FOR WHO YOU ARE */}
//       <section className="bg-[#FFF] py-16 px-8 lg:px-28">
//         <div className="max-w-[1440px] mx-auto">
//           <div className="text-[#2350BF] text-sm font-medium">02 — Why choose Sicunet</div>
//           <h2 className="text-3xl font-medium text-[#2350BF] mt-2">Built for who you are</h2>
//           <p className="text-[#5B5B5B] mt-4 max-w-md text-[16px] leading-relaxed">
//             Whether you install and maintain security systems for clients, or run a facility that needs protecting — Sicunet was designed with your needs at the center.
//           </p>

//           <div className="flex gap-4 mt-10 mb-12">
//             <button
//               onClick={() => setActiveTab("integrators")}
//               className={`px-8 py-3 rounded-xl font-medium transition-all ${activeTab === "integrators" ? "bg-[#2350BF] text-white" : "bg-white border border-gray-300 text-[#5B5B5B]"
//                 }`}
//             >
//               For integrators
//             </button>
//             <button
//               onClick={() => setActiveTab("endusers")}
//               className={`px-8 py-3 rounded-xl font-medium transition-all ${activeTab === "endusers" ? "bg-[#2350BF] text-white" : "bg-white border border-gray-300 text-[#5B5B5B]"
//                 }`}
//             >
//               For end users
//             </button>
//           </div>

//           <div className="flex flex-col lg:flex-row gap-16 items-center">
//             <div className="flex-1 flex justify-center">
//               <CompanyFig3 />
//             </div>

//             <div className="flex-1 space-y-6">
//               {(activeTab === "integrators" ? forYouFeatures : endUserFeatures).map((f, i) => (
//                 <div key={i} className="bg-[#E6ECFF4D] border border-white rounded-2xl p-6 flex gap-5 shadow-sm h-[152px]">
//                   <div className="w-[51px] h-[51px] bg-white rounded-2xl flex items-center justify-center flex-shrink-0 p-1">
//                     {f.icon}
//                   </div>
//                   <div>
//                     <div className="font-medium text-[#2350BF] text-[16px]">{f.title}</div>
//                     <div className="text-[#5B5B5B] text-sm leading-relaxed mt-2">{f.desc}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 03 — INDUSTRIES */}
//       <section className="py-16 px-8 lg:px-28 bg-[#F8F8F8]">
//         <div className="max-w-[1440px] mx-auto">
//           <div className="text-[#2350BF] text-sm font-medium">03 — What we do</div>
//           <h2 className="text-3xl font-medium text-[#2350BF] mt-2">Industries we protect</h2>
//           <p className="text-[#5B5B5B] mt-4 max-w-lg text-[16px] leading-relaxed">
//             From school campuses to financial institutions — Sicunet’s proven solutions are built to meet the specific demands of every environment.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
//             {industries.slice(0, 3).map((ind, i) => (
//               <IndustryCard key={i} {...ind} />
//             ))}
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 max-w-[700px] mx-auto">
//             {industries.slice(3).map((ind, i) => (
//               <IndustryCard key={i} {...ind} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* TECHNOLOGY & INTEGRATION */}
//       <section className="py-16 px-8 lg:px-28 bg-white">
//         <div className="max-w-[1440px] mx-auto">
//           <h2 className="text-3xl font-medium text-[#2350BF]">Technology &amp; integration</h2>
//           <p className="text-[#5B5B5B] mt-3 max-w-md">What every Sicunet deployment has built in — from first install to enterprise scale.</p>

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-12">
//             <div className="space-y-6">
//               {techFeatures.map((f, i) => (
//                 <div key={i} className="bg-[#E6ECFF4D] border border-[#BFD1FF] rounded-2xl p-6 flex gap-5">
//                   <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
//                     {f.icon}
//                   </div>
//                   <div>
//                     <div className="font-medium text-[#2350BF]">{f.title}</div>
//                     <div className="text-sm text-[#5B5B5B] mt-2 leading-relaxed">{f.desc}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="bg-[#F8FAFC] rounded-3xl p-12 flex items-center justify-center min-h-[520px]">
//               <CompanyFig2 />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FINAL CTA */}
//       <section className="py-16 px-8 lg:px-28 bg-[#F8F8F8]">
//         <div className="max-w-[1440px] mx-auto grid md:grid-cols-2 gap-16">
//           <div>
//             <h3 className="text-xl font-medium text-[#2350BF] mb-4">Ensuring Quality</h3>
//             <p className="text-[#5B5B5B] leading-relaxed">
//               We provide exceptional service and technical support, offering fast, reliable assistance for product inquiries, system troubleshooting, and maintenance needs.
//             </p>
//           </div>

//           <div>
//             <h3 className="text-xl font-medium text-[#2350BF] mb-4">Ready to secure your facility?</h3>
//             <p className="text-[#5B5B5B] leading-relaxed mb-8">
//               Talk to a Sicunet specialist — we’ll help you find the right solution for your size, budget, and industry.
//             </p>
//             <div className="flex gap-4">
//               <button className="bg-[#2350BF] text-white px-8 py-3 rounded-xl font-medium hover:bg-blue-700 transition">Request Demo</button>
//               <button className="border border-[#BFD1FF] text-[#2350BF] px-8 py-3 rounded-xl font-medium hover:bg-white/80 transition">Contact us</button>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// function IndustryCard({ icon, title, desc }) {
//   return (
//     <div className="bg-[#E6ECFF4D] border border-white rounded-2xl p-8 flex flex-col items-center text-center h-[220px] shadow-sm">
//       <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center mb-6">
//         {icon}
//       </div>
//       <div className="font-medium text-[#2350BF] text-[16px] mb-3">{title}</div>
//       <div className="text-sm text-[#5B5B5B] leading-relaxed">{desc}</div>
//     </div>
//   );
// }
// import { useState } from "react";
// import { ReactComponent as CompanyFig1 } from "../../../assets/svg/company-one.svg";
// import { ReactComponent as CompanyFig2 } from "../../../assets/svg/company-two.svg";
// import { ReactComponent as CompanyFig3 } from "../../../assets/svg/company-three.svg";
// import { endUserFeatures, forYouFeatures, industries, stats, techFeatures, whoWeAreFeatures } from "./CompanyData";


// export default function CompanyUI() {
//   const [activeTab, setActiveTab] = useState("integrators");

//   return (
//     <div className="font-sans ">
//       {/* HERO */}
//       <section className="pt-20 sm:pt-20 md:pt-28 pb-10 sm:pb-12 md:pb-16   px-4 sm:px-8 lg:px-[210px]  bg-[#FFF] ">
//         <div className="max-w-[680px]">
//           <h1 className="text-2xl sm:text-3xl md:text-[32px] font-medium leading-tight text-black">
//             We secure the places<br />
//             where people <span className="text-[#016EFC]">live and work</span>
//           </h1>
//           <p className="mt-4 sm:mt-6 text-[14px] sm:text-[15px] text-[#5B5B5B] leading-relaxed">
//             Sicunet Inc. is a Boston-area leader in physical access control and video security 20 years manufacturing hardware and software that protects over 100,000 installations worldwide.
//           </p>
//         </div>

//         <div className="mt-10 sm:mt-12 md:mt-16 flex flex-wrap justify-start sm:justify-end gap-8 sm:gap-12 md:gap-16">
//           {stats.map((s) => (
//             <div key={s.value} className="text-center">
//               <div className="text-3xl sm:text-4xl font-bold text-[#016EFC]">{s.value}</div>
//               <div className="text-xs sm:text-sm text-[#5B5B5B] mt-2">{s.label}</div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* 01 — WHO WE ARE */}
//       <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#FBFDFF]">
//         <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row gap-10 sm:gap-14 md:gap-24">
//           <div className="flex-1 max-w-full lg:max-w-[588px]">
//             <div className="text-[#016EFC] text-sm font-medium tracking-widest mb-3">01 — Who we are</div>
//             <h2 className="text-2xl sm:text-3xl font-medium text-[#2350BF] leading-tight mb-6 sm:mb-8">
//               Built in Boston. Trusted globally.
//             </h2>
//             <div className="space-y-4 sm:space-y-6 text-[#5B5B5B] text-[15px] sm:text-[16px] leading-[24px] sm:leading-[26px]">
//               <p>Sicunet Inc., headquartered in Norwood, Massachusetts, is a Boston-area leader in physical access control systems and security technology solutions.</p>
//               <p>With over 20 years of combined experience in the security industry, our team specializes in designing, manufacturing, and deploying advanced access control and video security systems that protect facilities of every size.</p>
//               <p>At Sicunet, we take pride in our service-first philosophy, building honest and transparent partnerships with security integrators and end users. Our feature-rich, cost-effective access control products help organizations enhance safety, streamline operations, and stay competitive in a rapidly evolving security landscape.</p>
//             </div>
//           </div>

//           <div className="flex-1 space-y-4 sm:space-y-6">
//             <div className="p-1 sm:p-4 overflow-hidden">
//               <CompanyFig1 className="w-full h-auto" />
//             </div>

//             {whoWeAreFeatures.map((f, i) => (
//               <div key={i} className="bg-white rounded-2xl p-4 sm:p-6 flex gap-4 sm:gap-5 border border-[#BFD1FF]">
//                 <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#EFF6FF] rounded-2xl flex items-center justify-center flex-shrink-0 text-xl sm:text-2xl">
//                   {f.icon}
//                 </div>
//                 <div>
//                   <div className="font-semibold text-[#0F172A] text-sm sm:text-base">{f.title}</div>
//                   <div className="text-xs sm:text-sm text-[#5B5B5B] mt-1">{f.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 02 — BUILT FOR WHO YOU ARE */}
//       <section className="bg-[#FFF] py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28">
//         <div className="max-w-[1440px] mx-auto">
//           <div className="text-[#016EFC] text-sm font-medium">02 — Why choose Sicunet</div>
//           <h2 className="text-2xl sm:text-3xl font-medium text-[#2350BF] mt-2">Built for who you are</h2>
//           <p className="text-[#5B5B5B] mt-3 sm:mt-4 max-w-md text-[15px] sm:text-[16px] leading-relaxed">
//             Whether you install and maintain security systems for clients, or run a facility that needs protecting — Sicunet was designed with your needs at the center.
//           </p>

//           <div className="flex flex-wrap gap-3 sm:gap-4 mt-8 sm:mt-10 mb-8 sm:mb-12">
//             <button
//               onClick={() => setActiveTab("integrators")}
//               className={`px-5 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium transition-all text-sm sm:text-base ${activeTab === "integrators" ? "bg-[#2350BF] text-white" : "bg-white border border-gray-300 text-[#5B5B5B]"
//                 }`}
//             >
//               For integrators
//             </button>
//             <button
//               onClick={() => setActiveTab("endusers")}
//               className={`px-5 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium transition-all text-sm sm:text-base ${activeTab === "endusers" ? "bg-[#2350BF] text-white" : "bg-white border border-gray-300 text-[#5B5B5B]"
//                 }`}
//             >
//               For end users
//             </button>
//           </div>

//           <div className="flex flex-col lg:flex-row gap-10 sm:gap-12 md:gap-16 items-center">
//             <div className="flex-1 flex justify-center w-full">
//               <CompanyFig3 className="w-full max-w-[420px]   lg:max-w-full h-[560px] " />
//             </div>

//             <div className="flex-1 space-y-4 sm:space-y-6 w-full">
//               {(activeTab === "integrators" ? forYouFeatures : endUserFeatures).map((f, i) => (
//                 <div key={i} className="bg-[#EAF0FF] border border-white items-center rounded-2xl p-2.5 sm:p-2.5 flex gap-4 sm:gap-5 shadow-sm min-h-[90px] sm:h-[122px]">
//                   <div className="w-10 h-10 sm:w-[51px] sm:h-[51px] bg-[#E0E9FF] rounded-2xl flex items-center justify-center flex-shrink-0 p-1">
//                     {f.icon}
//                   </div>
//                   <div>
//                     <div className="font-medium text-[#2350BF] text-[15px] sm:text-[16px]">{f.title}</div>
//                     <div className="text-[#5B5B5B] text-xs sm:text-sm leading-relaxed mt-1 sm:mt-2">{f.desc}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 03 — INDUSTRIES */}
//       <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#F8F8F8]">
//         <div className="max-w-[1440px] mx-auto">
//           <div className="text-[#2350BF] text-sm font-medium">03 — What we do</div>
//           <h2 className="text-2xl sm:text-3xl font-medium text-[#2350BF] mt-2">Industries we protect</h2>
//           <p className="text-[#5B5B5B] mt-3 sm:mt-4 max-w-lg text-[15px] sm:text-[16px] leading-relaxed">
//             From school campuses to financial institutions — Sicunet's proven solutions are built to meet the specific demands of every environment.
//           </p>

//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
//             {industries.slice(0, 3).map((ind, i) => (
//               <IndustryCard key={i} {...ind} />
//             ))}
//           </div>
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-6 max-w-full md:max-w-[700px] mx-auto">
//             {industries.slice(3).map((ind, i) => (
//               <IndustryCard key={i} {...ind} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* TECHNOLOGY & INTEGRATION */}
//       <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-white">
//         <div className="max-w-[1440px] mx-auto">
//           <h2 className="text-2xl sm:text-3xl font-medium text-[#016EFC]">Technology &amp; integration</h2>
//           <p className="text-[#5B5B5B] mt-2 sm:mt-3 max-w-md text-sm sm:text-base">What every Sicunet deployment has built in — from first install to enterprise scale.</p>

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 md:gap-16 mt-8 sm:mt-12">
//             <div className="space-y-4 sm:space-y-6">
//               {techFeatures.map((f, i) => (
//                 <div key={i} className=" border border-[#BFD1FF] rounded-2xl p-4 sm:p-6 flex gap-4 sm:gap-5">
//                   <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#E0E9FF] rounded-2xl flex items-center justify-center flex-shrink-0">
//                     {f.icon}
//                   </div>
//                   <div>
//                     <div className="font-medium text-[#2350BF] text-sm sm:text-base">{f.title}</div>
//                     <div className="text-xs sm:text-sm text-[#5B5B5B] mt-1 sm:mt-2 leading-relaxed">{f.desc}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="  p-8 sm:p-12 flex items-center justify-center min-h-[300px] sm:min-h-[420px] lg:min-h-[520px] overflow-hidden">
//               <CompanyFig2 className="w-full h-auto" />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FINAL CTA */}
//       <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#F8F8F8]">
//         <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-12 md:gap-16">
//           <div>
//             <h3 className="text-lg sm:text-xl font-medium text-[#5B5B5B] mb-3 sm:mb-4">Ensuring Quality</h3>
//             <p className="text-[#5B5B5B] leading-relaxed text-sm sm:text-base">
//               We provide exceptional service and technical support, offering fast, reliable assistance for product inquiries, system troubleshooting, and maintenance needs.
//             </p>
//           </div>

//           <div>
//             <h3 className="text-lg sm:text-xl font-medium text-[#5B5B5B] mb-3 sm:mb-4">Ready to secure your facility?</h3>
//             <p className="text-[#5B5B5B] leading-relaxed mb-6 sm:mb-8 text-sm sm:text-base">
//               Talk to a Sicunet specialist — we'll help you find the right solution for your size, budget, and industry.
//             </p>
//             <div className="flex flex-wrap gap-3  sm:gap-4">
//               <button className="bg-[#2350BF] text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium hover:bg-blue-700 transition text-sm sm:text-base">Request Demo</button>
//               <button className="border border-[#BFD1FF] text-[#171717] px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium hover:bg-white/80 transition text-sm sm:text-base">Contact us</button>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// function IndustryCard({ icon, title, desc }) {
//   return (
//     <div className="bg-[#EAF0FF] border border-white rounded-2xl p-6 sm:p-8 flex flex-col items-center text-center min-h-[180px] sm:h-[220px] shadow-sm">
//       <div className="w-10 h-10 sm:w-[51px] sm:h-[51px] bg-[#E0E9FF] rounded-2xl flex items-center justify-center flex-shrink-0 p-1">
//         {icon}
//       </div>
//       <div className="font-medium text-[#2350BF] text-[15px] sm:text-[16px] mb-2 sm:mb-3">{title}</div>
//       <div className="text-xs sm:text-sm text-[#5B5B5B] leading-relaxed">{desc}</div>
//     </div>
//   );
// }
import { useState } from "react";
import { ReactComponent as CompanyFig1 } from "../../../assets/svg/company-one.svg";
import { ReactComponent as CompanyFig2 } from "../../../assets/svg/company-two.svg";
import { ReactComponent as CompanyFig3 } from "../../../assets/svg/company-three.svg";
import { endUserFeatures, forYouFeatures, industries, stats, techFeatures, whoWeAreFeatures } from "./CompanyData";
import { Navigate, useNavigate } from "react-router-dom";

export default function CompanyUI() {
  const [activeTab, setActiveTab] = useState("integrators");
  const navigate = useNavigate();

  return (
    <div className="font-sans">
      {/* HERO */}
      <section className="pt-20 sm:pt-20 md:pt-28 pb-10 sm:pb-12 md:pb-16 px-4 sm:px-8 lg:px-28 bg-[#FFF]">
        <div className="max-w-[1440px] mx-auto">
          <div className="max-w-[680px]">
            <h1 className="text-2xl sm:text-3xl md:text-[32px] font-medium leading-tight text-black">
              We secure the places<br />
              where people <span className="text-[#016EFC]">live and work</span>
            </h1>
            <p className="mt-4 sm:mt-6 text-[14px] sm:text-[15px] text-[#5B5B5B] leading-relaxed">
              Sicunet Inc. is a Boston-area leader in physical access control and video security 20 years manufacturing hardware and software that protects over 100,000 installations worldwide.
            </p>
          </div>

          <div className="mt-10 sm:mt-12 md:mt-16 flex flex-wrap justify-start sm:justify-end gap-8 sm:gap-12 md:gap-16">
            {stats.map((s) => (
              <div key={s.value} className="text-center">
                <div className="text-3xl sm:text-4xl font-bold text-[#5896FA]">{s.value}</div>
                <div className="text-xs sm:text-sm text-[#5B5B5B] mt-2">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 01 — WHO WE ARE */}
      <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#F8F8F8]">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row gap-10 sm:gap-14 md:gap-24">
          <div className="flex-1 max-w-full lg:max-w-[588px]">
            <div className="text-[#016EFC] text-sm font-medium tracking-widest mb-3">01 — Who we are</div>
            <h2 className="text-2xl sm:text-3xl font-medium text-[#2350BF] leading-tight mb-6 sm:mb-8">
              Built in Boston. Trusted globally.
            </h2>
            <div className="space-y-4 sm:space-y-6 text-[#5B5B5B] text-[15px] sm:text-[16px] leading-[24px] sm:leading-[26px]">
              <p>Sicunet Inc., headquartered in Norwood, Massachusetts, is a Boston-area leader in physical access control systems and security technology solutions.</p>
              <p>With over 20 years of combined experience in the security industry, our team specializes in designing, manufacturing, and deploying advanced access control and video security systems that protect facilities of every size.</p>
              <p>At Sicunet, we take pride in our service-first philosophy, building honest and transparent partnerships with security integrators and end users. Our feature-rich, cost-effective access control products help organizations enhance safety, streamline operations, and stay competitive in a rapidly evolving security landscape.</p>
            </div>
          </div>

          <div className="flex-1 space-y-4 sm:space-y-6">
            <div className="p-1 sm:p-4 overflow-hidden">
              <CompanyFig1 className="w-full h-auto" />
            </div>

            {whoWeAreFeatures.map((f, i) => (
              <div key={i} className="bg-white rounded-2xl p-4 sm:p-6 flex gap-4 sm:gap-5 border border-[#BFD1FF]">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#EFF6FF] rounded-2xl flex items-center justify-center flex-shrink-0 text-xl sm:text-2xl">
                  {f.icon}
                </div>
                <div>
                  <div className="font-semibold text-[#5B5B5B] text-sm sm:text-base">{f.title}</div>
                  <div className="text-xs sm:text-sm text-[#5B5B5B] mt-1">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 02 — BUILT FOR WHO YOU ARE */}
      <section className="bg-[#FFF] py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-[#016EFC] text-sm font-medium">02 — Why choose Sicunet</div>
          <h2 className="text-2xl sm:text-3xl font-medium text-[#2350BF] mt-2">Built for who you are</h2>
          <p className="text-[#5B5B5B] mt-3 sm:mt-4 max-w-md text-[15px] sm:text-[16px] leading-relaxed">
            Whether you install and maintain security systems for clients, or run a facility that needs protecting — Sicunet was designed with your needs at the center.
          </p>

          <div className="flex flex-wrap gap-3 sm:gap-4 mt-8 sm:mt-10 mb-8 sm:mb-12">
            <button
              onClick={() => setActiveTab("integrators")}
              className={`px-5 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium transition-all text-sm sm:text-base ${activeTab === "integrators" ? "bg-[#2F6BFF] text-white" : "bg-white border border-gray-300 text-[#5B5B5B]"}`}
            >
              For integrators
            </button>
            <button
              onClick={() => setActiveTab("endusers")}
              className={`px-5 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium transition-all text-sm sm:text-base ${activeTab === "endusers" ? "bg-[#2F6BFF] text-white" : "bg-white border border-[#2F6BFF] text-[#5B5B5B]"}`}
            >
              For end users
            </button>
          </div>

          <div className="flex flex-col lg:flex-row gap-10 sm:gap-12 md:gap-16 items-center">
            <div className="flex-1 flex justify-center w-full">
              <CompanyFig3 className="w-full max-w-[420px] lg:max-w-full h-[560px]" />
            </div>

            <div className="flex-1 space-y-4 sm:space-y-6 w-full">
              {(activeTab === "integrators" ? forYouFeatures : endUserFeatures).map((f, i) => (
                <div key={i} className="bg-[#EAF0FF] border border-white items-center rounded-2xl p-2.5 sm:p-2.5 flex gap-4 sm:gap-5 shadow-sm min-h-[90px] sm:h-[122px]">
                  <div className="w-10 h-10 sm:w-[51px] sm:h-[51px] bg-[#E0E9FF] rounded-2xl flex items-center justify-center flex-shrink-0 p-1">
                    {f.icon}
                  </div>
                  <div>
                    <div className="font-medium text-[#2350BF] text-[15px] sm:text-[16px]">{f.title}</div>
                    <div className="text-[#5B5B5B] text-xs sm:text-sm leading-relaxed mt-1 sm:mt-2">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 03 — INDUSTRIES */}
      <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#F8F8F8]">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-[#016EFC] text-sm font-medium">03 — What we do</div>
          <h2 className="text-2xl sm:text-3xl font-medium text-[#2350BF] mt-2">Industries we protect</h2>
          <p className="text-[#5B5B5B] mt-3 sm:mt-4 max-w-lg text-[15px] sm:text-[16px] leading-relaxed">
            From school campuses to financial institutions — Sicunet's proven solutions are built to meet the specific demands of every environment.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
            {industries.slice(0, 3).map((ind, i) => (
              <IndustryCard key={i} {...ind} />
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-6 max-w-full md:max-w-[700px] mx-auto">
            {industries.slice(3).map((ind, i) => (
              <IndustryCard key={i} {...ind} />
            ))}
          </div>
        </div>
      </section>

      {/* TECHNOLOGY & INTEGRATION */}
      <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#FFF]">
        <div className="max-w-[1440px] mx-auto">
          <h2 className="text-2xl sm:text-3xl font-medium text-[#016EFC]">Technology &amp; integration</h2>
          <p className="text-[#5B5B5B] mt-2 sm:mt-3 max-w-md text-sm sm:text-base">What every Sicunet deployment has built in — from first install to enterprise scale.</p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 md:gap-16 mt-8 sm:mt-12">
            <div className="space-y-4 sm:space-y-6">
              {techFeatures.map((f, i) => (
                <div key={i} className="border border-[#BFD1FF] rounded-2xl p-4 sm:p-6 flex gap-4 sm:gap-5">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#E0E9FF] rounded-2xl flex items-center justify-center flex-shrink-0">
                    {f.icon}
                  </div>
                  <div>
                    <div className="font-medium text-[#5B5B5B] text-sm sm:text-base">{f.title}</div>
                    <div className="text-xs sm:text-sm text-[#5B5B5B] mt-1 sm:mt-2 leading-relaxed">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="p-8 sm:p-12 flex items-center justify-center min-h-[300px] sm:min-h-[420px] lg:min-h-[520px] overflow-hidden">
              <CompanyFig2 className="w-full h-auto" />
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-10 sm:py-12 md:py-16 px-4 sm:px-8 lg:px-28 bg-[#F8F8F8]">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-12 md:gap-16">
          <div>
            <h3 className="text-lg sm:text-xl font-medium text-[#5B5B5B] mb-3 sm:mb-4">Ensuring Quality</h3>
            <p className="text-[#5B5B5B] leading-relaxed text-sm sm:text-base">
              We provide exceptional service and technical support, offering fast, reliable assistance for product inquiries, system troubleshooting, and maintenance needs.
            </p>
          </div>

          <div>
            <h3 className="text-lg sm:text-xl font-medium text-[#5B5B5B] mb-3 sm:mb-4">Ready to secure your facility?</h3>
            <p className="text-[#5B5B5B] leading-relaxed mb-6 sm:mb-8 text-sm sm:text-base">
              Talk to a Sicunet specialist — we'll help you find the right solution for your size, budget, and industry.
            </p>
            <div className="flex flex-wrap gap-3 sm:gap-4">
              <button onClick={() => navigate("/request-demo")} className="bg-[#2F6BFF] text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium hover:bg-blue-700 transition text-sm sm:text-base">Request Demo</button>
              <button onClick={() => navigate("/contact-us")} className="border border-[#2F6BFF] text-[#171717] px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl font-medium hover:bg-white/80 transition text-sm sm:text-base">Contact us</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function IndustryCard({ icon, title, desc }) {
  return (
    <div className="bg-[#EAF0FF] border border-white rounded-2xl p-6 sm:p-8 flex flex-col items-center text-center min-h-[180px] sm:h-[220px] shadow-sm">
      <div className="w-10 h-10 sm:w-[51px] sm:h-[51px] bg-[#E0E9FF] rounded-2xl flex items-center justify-center flex-shrink-0 p-1">
        {icon}
      </div>
      <div className="font-medium text-[#2350BF] text-[15px] sm:text-[16px] mb-2 sm:mb-3">{title}</div>
      <div className="text-xs sm:text-sm text-[#5B5B5B] leading-relaxed">{desc}</div>
    </div>
  );
}